import React, { useState, useEffect } from 'react';
import Table from '../../Components/Table';
import { ServiceLevelColumns } from '../../ColumnsConfig/ServiceLevelColumns';
import './../../App.css';
import { Box, Button, Chip, IconButton, InputBase, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ServiceLevelDialog from '../../Modals/ServiceLevelDialog';
import ConfirmationModal from '../../Common/ConfirmationModal';
import ServiceLevelService from '../../Services/ServiceLevelService';
import loaderGif from "../../Assests/loader.gif";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const ServiceLevel = () => {
  const [searchValue, setSearchValue] = useState('');
  const [chipValue, setChipValue] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortColumn] = useState('');
  const [order, setSortOrder] = useState('asc');
const [serviceLevel, setServiceLevel] = useState('');
  const validSortFields = ['service_level',];

  const fetchServiceLevelData = async (
    page = currentPage,
    size = pageSize,
    sortByField = sortBy,
    sortOrder = order,
    searchTerm = serviceLevel
  ) => {
    setIsLoading(true);
    try {
      const queryObj = {
        page,
        pageSize: size,
        sortBy: validSortFields.includes(sortByField) ? sortByField : 'service_level',
        order: sortOrder,
        searchTerm: searchTerm.trim() || "",
      };
  
      const response = await ServiceLevelService.fetchServiceLevel(
        queryObj.page,
        queryObj.pageSize,
        queryObj.sortBy,
        queryObj.order,
        queryObj.searchTerm,
      );
  console.log("response.data--------------",response.data)
      const { data, totalRecords, totalPages } = response;
  
      if (Array.isArray(data)) {
        setRows(data.map(row => ({ ...row, id: row.service_level_id })));
        setTotalRecords(totalRecords);
        setTotalPages(totalPages);
      } else {
        throw new Error('Unexpected API response format.');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.ErrorMessage || "Failed to fetch ServiceLevel data.";
      console.error('Failed to fetch ServiceLevel data:', errorMessage);
      NotificationManager.error(errorMessage, "Error", 5000);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchServiceLevelData();
  }, [currentPage, pageSize]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    fetchServiceLevelData(page, size, sortBy, order);
  };

  const handleSearchChange = e => setSearchValue(e.target.value);

  const handleSort = (field) => {
    let sortField = field;
  
    if (field === 'service_level') {
      sortField = 'service_level';
    }
  
    if (!validSortFields.includes(sortField)) {
      console.warn(`Invalid sort field: "${sortField}"`);
      return;
    }
  
    const newOrder = sortBy === sortField && order === 'asc' ? 'desc' : 'asc';
    setSortColumn(sortField);
    setSortOrder(newOrder);
  
    fetchServiceLevelData(currentPage, pageSize, sortField, newOrder);
  };
  
  const handleSearch = () => {
    const trimmedSearchTerm = serviceLevel.trim(); 
    setChipValue(trimmedSearchTerm);
    fetchServiceLevelData(1, pageSize, sortBy, order, trimmedSearchTerm); 
  };

  const handleChipDelete = async() => {
    setChipValue('');
    try{
      await fetchServiceLevelData(1, pageSize, sortBy, order, '');
  
    }catch(error){
      console.error('Error fetching SCAC data:', error);
      //NotificationManager.error("Failed to fetch SCAC data.", "Error", 5000);
    }finally{
      setServiceLevel('');
    }
  };

  const handleDialogOpen = () => {
    setInitialData(null);
    setIsDialogOpen(true);
  };

  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setIsDialogOpen(false);
    }
  };

  const handleSave = async (formData) => {
      try {
        console.log("formData",formData)
          const { service_level} = formData;
          const dataToSubmit = {service_level};

          if (formData.service_level_id) {
              await ServiceLevelService.updateServiceLevel(formData.service_level_id, dataToSubmit);
              NotificationManager.success("ServiceLevel Updated successfully.", "Success", 3000);
          } else {
              await ServiceLevelService.createServiceLevel(dataToSubmit);
              NotificationManager.success("ServiceLevel saved successfully.", "Success", 3000);

          }

          fetchServiceLevelData(); // Refresh the table data
          setIsDialogOpen(false);
      } catch (error) {
          const errorMessage = error.response?.data?.ErrorMessage || "Failed to save ServiceLevel.";
          console.error('Error saving ServiceLevel:', errorMessage);
          NotificationManager.error(errorMessage, "Error", 5000);
      }
  };

  const handleEdit = rowData => {
    setInitialData(rowData);
    setIsDialogOpen(true);
  };

  const handleDelete = rowData => {
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await ServiceLevelService.deleteServiceLevel(rowToDelete.id);
      setRows(rows.filter(row => row.id !== rowToDelete.id));
      setIsDeleteModalOpen(false);
      NotificationManager.success('ServiceLevel deleted successfully.', 'Success', 3000);
    } catch (error) {
      console.error('Error deleting ServiceLevel:', error);
      NotificationManager.error('Failed to delete ServiceLevel.', 'Error', 5000);
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <div className="px-5 my-1">
      <NotificationContainer />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          <Paper component="form" className="search-container" onSubmit={(e) => e.preventDefault()}>
            <InputBase
              className="search-input"
              placeholder="Search ServiceLevel"
              inputProps={{ 'aria-label': 'search ServiceLevel' }}
              value={serviceLevel}
              onChange={(e) => setServiceLevel(e.target.value)}
            />
            <IconButton type="button" aria-label="search" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Paper>
          {chipValue && (
            <Chip
              label={chipValue}
              onDelete={handleChipDelete}
              deleteIcon={<CloseIcon />}
              className="chip-style"
            />
          )}
        </Box>
        <Button variant="contained" className="add-new-btn" onClick={handleDialogOpen}>
          Add New ServiceLevel
        </Button>
      </Box>

      <Table
        rows={rows}
        columns={ServiceLevelColumns(handleEdit, handleDelete)}
        className="table-header"
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        onPageChange={handlePageChange}
        totalPages={totalPages}
        getRowId={row => row.id}
        onSort={handleSort}
      />

      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.8)"
          zIndex={1}
        >
          <img src={loaderGif} alt="Loading..." width={50} height={50} />
        </Box>
      )}

      <ServiceLevelDialog
        open={isDialogOpen}
        handleClose={handleDialogClose}
        handleSave={handleSave}
        initialData={initialData}
      />
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to delete this ServiceLvele?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};

export default ServiceLevel;
